import { FormEvent } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from '@reduxjs/toolkit'
import { Box,Flex } from 'rebass'
import styled from 'styled-components'

import type { ClaimHandlerType } from '../claim/types'
import { Select } from '../shared/styledComponents'
import type { GlobalState } from '../types'
import { uploadSelectHandler } from './upload-actions'
import { getClaimHandlers } from './upload-selectors'

const StyledFlex = styled(Flex)`
  padding-bottom: 36px;
`

const StyledSelect = styled(Select)`
  margin-top: 10px;
  text-transform: capitalize;
`

type ClaimHandlerSelectProps = {
  claimHandlers: ClaimHandlerType[]
  requesting: boolean
  handler: string
  onSelectHandler(arg: string): void
}

const ClaimHandlerSelectComponent = (props: ClaimHandlerSelectProps) => {
  const { claimHandlers, requesting, handler } = props

  const handleHandlerChange = (event: FormEvent<HTMLSelectElement>) => {
    if (!event.currentTarget.value) {
      return
    }
    props.onSelectHandler(event.currentTarget.value)
  }

  if (claimHandlers.length === 0) {
    return <></>
  }

  return (
    <StyledFlex flexWrap='wrap'>
      <Box width={[1, 1 / 3]}>
        <label htmlFor='claimHandlerSelection'>Recipient</label>
      </Box>
      <Box width={[1, 2 / 3]}>
        <StyledSelect
          id='claimHandlerSelection'
          role='listbox'
          onChange={handleHandlerChange}
          disabled={requesting}
          value={handler}
          autoFocus // eslint-disable-line jsx-a11y/no-autofocus
        >
          <option value="">Select Option</option>
          { claimHandlers.map((claimhandler, index) =>
            <option key={index} value={claimhandler.contactUId}>
              {claimhandler.name.toLowerCase()}
            </option>
          )}
          <option value='other'>Unknown/Not Listed</option>
        </StyledSelect>
      </Box>
    </StyledFlex>
  )
}

const mapStateToProps = (state: GlobalState) => ({
  claimHandlers: getClaimHandlers(state),
  requesting: state.upload.requesting,
  handler: state.upload.handler
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSelectHandler: (handler: string) => dispatch(uploadSelectHandler(handler))
})

const ClaimHandlerSelect = connect(mapStateToProps, mapDispatchToProps)(ClaimHandlerSelectComponent)

export {
  ClaimHandlerSelect,
  ClaimHandlerSelectComponent // for testing without connect
}
